import React from 'react';

import { useTranslation } from '@common/hooks/translation';
import NumericInput from '@common/components/numericInput';
import { formatCpfNumber } from '@app/dev/helpers/formatCpfNumber';

export const CpfPhoneNumber = ({ form, errors, setForm }) => {
  const t = useTranslation();
  return (
    <>
      <div className="info-row">
        <p className="info-row-text">{t('provide your login information')}</p>
      </div>


      <div className="input-wrapper">
        <p className="popup-txt">{t('CPF NUMBER')}</p>
        <div className="input-row">
          <NumericInput
            className="numeric-input"
            onChange={(value) => setForm({ ...form, cpf: formatCpfNumber(value) })}
            value={form.cpf}
            customFormat
          />
        </div>
        {errors.cpf && (
          <div className="error-row">
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">{t(errors.cpf)}</p>
          </div>
        )}
        <p className="popup-txt">{t('Phone Number')}</p>
        <div className="input-row">
          <NumericInput
            className="numeric-input"
            onChange={(value) => setForm({ ...form, phoneNumber: value })}
            value={form.phoneNumber}
          />
        </div>
        {errors.phoneNumber && (
          <div className="error-row">
            <i className="global-icon icon-toast-error error-icon-cont" />
            <p className="error-row-text">{t(errors.phoneNumber)}</p>
          </div>
        )}
      </div>
    </>
  );
};
